import type { State } from './vuex';

export default {
  mayChangeScoreItems(state: State): boolean {
    return !!state.course && state.course.status !== 'published';
  },
};
